<template>
  <div class="addmodal fixed w-full h-screen z-20 top-0 left-0 flex justify-center items-start overflow-auto">
    <div class="bg-white m-auto w-9/12 md:w-7/12 h-auto flex flex-col rounded-md justify-center items-center">
      <h2
        class="font-costea w-11/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
        Crear Usuario
      </h2>
      <!-- <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4">
        <span @click="$refs.myFiles.click()"
          class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
          <i class="ri-camera-fill text-lg"></i>
          <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles" style="display:none" />
        </span>
      </div> -->
      <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4"
        :style="'background:' + showImage + ' no-repeat; background-size: cover; background-position:center'">
        <span @click="$refs.myFiles.click()"
          class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
          <i class="ri-camera-fill text-lg"></i>
          <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles" style="display:none" />
        </span>
      </div>

      <p v-if="errorSizeImage"
        class="text-costeaSalmon font-costea text-t12 text-left w-11/12 bg-costeaSalmonDisabled px-2 py-1 rounded-md ">
        {{ this.errorSizeImage }}</p>


      <form @submit.prevent="validateUsers" class="flex flex-col justify-start items-center w-11/12">
        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-full rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Usuario (e-mail)*
            </p>
            <input autocomplete="off" id="email" type="email" v-model="emailUser" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              placeholder="example@dominio.com">
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-full sm:w-6/12 rounded-md">
            <p for="password" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Contraseña*</p>
            <div
              class="border-gray-400 border w-full h-auto flex justify-start items-center outline-none pr-2 rounded-md text-t14">
              <input autocomplete="off" :type="typeControl" v-model="password" id="password" required
                class="placeholder-gray-300 w-full flex justify-start items-center outline-none py-2 px-3 rounded-md text-t16"
                placeholder="Contraseña">
              <i @click="showPassword('password')"
                :class="iconShowPassword + ' w-6 text-costeaGray h-full flex items-center content-center text-xl cursor-pointer'"></i>
            </div>
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-full sm:w-6/12 rounded-md">
            <p for="confirmPassword"
              :class="['w-full text-costeaGray items-center content-center text-t16 mb-3', { 'text-red-700': confirmPass }]">
              Confirmar contraseña*</p>
            <div
              :class="['border-gray-400 border w-full h-auto flex justify-start items-center outline-none pr-2 rounded-md text-t14', { 'border-red-700': confirmPass }]">
              <input :type="typeControl" v-model="confirmPassword" id="confirmPassword" required
                class="placeholder-gray-300 w-full flex justify-start items-center outline-none py-2 px-3 rounded-md text-t16"
                placeholder="Contraseña">
              <i @click="showPassword('confirmPassword')"
                :class="iconShowPassword + ' w-6 text-costeaGray h-full flex items-center content-center text-xl cursor-pointer'"></i>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Nombre: *</p>
            <input id="name" type="text" v-model="name" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              placeholder="Primer Nombre">
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Apellido: *</p>
            <input id="last_name" type="text" v-model="last_name" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              placeholder="Primer Apellido">
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Teléfono: *</p>
            <input id="telephone" type="text" v-model="telephone" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              placeholder="Teléfono de contacto">
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Rol: *</p>
               <select class="bg-white text-black-900 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide" required v-model="role_id" @change="updateRoleId">
      <!-- <option class="text-black" value="1">1 - Super Administrador</option> -->
      <option class="text-black" value="2">2 - Administrador</option>
      <option class="text-black" value="3">3 - Consulta</option>
    </select>
          </div>
        </div>

        <div class="mb-4 p-2 flex content-center items-center w-10/12 rounded-md justify-end">
          <button
            class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4"
            @click="toggleModal()" type="button">Cancelar</button>
          <div v-show="this.buttonText == 'Creando...'"
            class="bg-costeaPrimary rounded-md text-white duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4">
            Creando...</div>
          <button :disabled="this.disabledButton" v-show="this.buttonText == 'Crear' || this.buttonText == '¡Listo!'"
            :class="'rounded-md text-white hover:bg-costeaHover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide ml-4 ' + buttonBg"
            type="submit">{{ buttonText }}</button>
        </div>
      </form>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      notValid: '',

      iconShowPassword: 'ri-eye-off-line',
      typeControl: 'password',

      iconShowPassword2: 'ri-eye-off-line',
      typeControl2: 'password',

      cop: false,
      usd: false,
      buttonText: 'Crear',
      buttonBg: 'bg-costeaPrimary',
      modalAct: true,

      disabledButton: false,

      name: '',
      last_name: '',
      doc_type: 'ID',
      num_doc_type: '12345678',
      emailUser: '',
      password: '',
      confirmPassword: '',
      role_id: '',
      telephone: '',
      gender: 'x',
      picture: null,
      previewImage: null,
      selected :0,


      errorSizeImage: '',
    }
  },
  computed: {
    ...mapState(['costea']),
    confirmPass() {
      if (this.confirmPassword != '') {
        if (this.confirmPassword === this.password) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.notValid = false
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.notValid = true
        }
      }
      return this.notValid
    },
    showImage() {
      if (this.previewImage != null) {
        return 'url(' + this.previewImage + ')'
      } else {
        return '#f1f2f3'
      }
    },

  },
  methods: {
    onSelectedImage(event) {
      this.picture = event.target.files[0]
    },
    pickFile() {
      let input = this.$refs.myFiles
      let file = input.files
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(file[0])
      }
    },
    validateUsers() {
      if (this.notValid === false) {
        this.buttonText = 'Creando...'
        this.setUsers()
      } else {
        this.notValid = true
      }
    },
    setUsers: function () {
      this.errorSizeImage = ''
      if (this.picture && this.picture.size > 450000) {
        this.errorSizeImage = 'El tamaño de la imagen no puede ser mayor a 450kb'
        this.buttonText = 'Crear'
        return
      }

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let formData = new FormData()
      if (this.picture != null) {
        formData.append('picture', this.picture);
      }
      formData.append('name', this.name);
      formData.append('last_name', this.last_name)
      formData.append('doc_type', this.doc_type)
      formData.append('num_doc_type', this.num_doc_type)
      formData.append('email', this.emailUser)
      formData.append('password', this.password)
      formData.append('role_id', this.role_id)
      formData.append('telephone', this.telephone)
      formData.append('gender', this.gender)
      axios
        .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}register-user`,
          formData, config)
        .then(() => {
          setTimeout(() => {
            this.buttonText = 'Listo!'
            this.disabledButton = true
            this.buttonBg = 'bg-costeaDarkGreen'
          }, 100)
          setTimeout(() => {
            this.toggleModal()
          }, 1000)
          setTimeout(() => {
            this.buttonText = 'Crear'
            this.disabledButton = false
            this.buttonBg = 'bg-costeaPrimary'
          }, 3000)
        }
        ).catch(
          (error) => {
            console.log(error)

          }
        );
    },
    modalActive() {
      this.modalAct = true
      this.modalAct == true ? this.modalAct = false : this.modalAct = true
      return this.modalAct
    },
    toggleModal() {
      this.$emit('closeModalAdd', this.modalActive())
      this.$emit('reloadData', true)
    },
    onProcess() {
      this.buttonText = 'Creando...'
    },

    //Bonus
    showPassword: function (action) {
      if (action == 'password') {
        if (this.typeControl === "password") {
          this.typeControl = "text";
          this.iconShowPassword = "ri-eye-line";
        } else {
          this.typeControl = 'password';
          this.iconShowPassword = "ri-eye-off-line";
        }
      } else {
        if (this.typeControl2 === "password") {
          this.typeControl2 = "text";
          this.iconShowPassword2 = "ri-eye-line";
        } else {
          this.typeControl2 = 'password';
          this.iconShowPassword2 = "ri-eye-off-line";
        }
      }
    }
  }
}
</script>

<style scoped>
.addmodal {
  background: rgba(0, 0, 0, 0.6);
}
</style>